import React from "react";
import { Lock } from "lucide-react";

export const AUTH_INPUT = "mt-1.5 w-full rounded-xl border border-white/10 bg-white/5 px-4 py-2.5 text-sm text-white outline-none transition focus:border-brand focus:bg-white/10";
export const AUTH_LABEL = "mt-4 block text-[11px] font-semibold uppercase tracking-wider text-white/50";

export function AuthShell({ onSubmit, subtitle = "Back-office · khusus staf", children, testid }) {
  return (
    <div className="sidebar-dark flex min-h-screen items-center justify-center p-4 sm:p-6" data-testid={testid}>
      <form onSubmit={onSubmit} className="fade-up w-full max-w-sm rounded-3xl border border-white/10 bg-navy-2/90 p-6 text-white shadow-2xl backdrop-blur sm:p-8">
        <div className="flex items-center gap-2.5"><span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand shadow-[0_6px_16px_rgba(37,99,235,.35)]"><Lock size={16} /></span><div><p className="text-sm font-black tracking-tight">Oryntix Platform</p><p className="text-[11px] text-white/50">{subtitle}</p></div></div>
        {children}
      </form>
    </div>
  );
}
